var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient, createApiError } from '../interceptor/interceptor';
/**
 * Generate referral order preview PDF.
 *
 * @throws ApiError if request fails (handled by interceptor)
 */
export const getReferralOrderPreviewPdf = (patientId, body) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    // Ensure patientId in body matches path param
    body.patientId = patientId;
    const response = yield apiClient.post(`/screener/reports/referral-order/patient/${patientId}`, body !== null && body !== void 0 ? body : {}, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const blob = response.data;
    // Validate content type
    const contentType = (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a['content-type']) !== null && _b !== void 0 ? _b : '';
    if (contentType && !contentType.toLowerCase().includes('application/pdf')) {
        const text = yield blob.text().catch(() => '');
        throw createApiError(text || `Unexpected response content-type: ${contentType}`, response.status, response);
    }
    return blob;
});
/**
 * Submit EHR order writeback for a patient.
 *
 * Calls the unified EHR orders writeback endpoint which routes to the correct
 * strategy (Epic HL7v2, Athena lab order) based on tenant type.
 *
 * @param patientId - Patient ID for whom to submit the writeback
 * @param tenantId - Tenant identifier (FHIR base URL / issuer)
 * @param encounterId - EHR encounter ID (required for Athena, optional for Epic)
 * @returns Response data from the writeback API
 * @throws ApiError if request fails (handled by interceptor)
 */
export const submitEhrOrderWriteback = (patientId, tenantId, encounterId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.post(`/ehr/orders/writeback/${patientId}`, encounterId ? { encounterId } : {}, {
        params: { tenantId },
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
});
/**
 * Submit Epic order referral for a patient.
 *
 * Calls the EHR Epic orders referral endpoint to submit the referral to Epic.
 *
 * @param patientId - Patient ID for whom to submit the referral
 * @returns Response data from the referral API
 * @throws ApiError if request fails (handled by interceptor)
 */
export const submitEpicOrderReferral = (patientId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.post(`/consult-orders/patients/${patientId}/submit`, {}, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
});
